module.exports = __webpack_public_path__ + "static/img/shuiji6.df086310.webp";